import { isNumericColumn } from '@/shared/utils';

/**
 * A preview table prints an absent cell as an em dash (`renderTableCell` in
 * `output-card-utils`), so a gap in a column of figures must not be read as a
 * word.
 */
const MISSING_VALUE = '—';

/**
 * Which columns of a preview table hold quantities, judged from the values
 * they hold rather than their names: a column called `total` full of words is
 * not a column of figures, and `id_count` full of digits is.
 *
 * The alignment of a header and of its cells share this answer, so a
 * right-aligned column never sits under a left-aligned label.
 *
 * @param headers - The table's headers, one per column
 * @param rows - The table's rows, as displayed
 * @returns One flag per column, in header order
 */
export function getNumericOutputColumns(
  headers: string[],
  rows: string[][],
): boolean[] {
  return headers.map((_, index) =>
    isNumericColumn(
      rows.map(row => {
        const cell = row[index] ?? '';
        return cell === MISSING_VALUE ? '' : cell;
      }),
    ),
  );
}
